import React from 'react';
import { Button, Form, Table, Modal, Badge } from 'react-bootstrap';
import API from '../../../API'

// Models
import Group from '../Models/Group'
import Contact from '../Models/Contact'
import ContactMember from '../Models/ContactMember'

export interface ManageGroupModalProps {
    group:Group;
    show: boolean;
    didPressDone: () => void;
}

type ManageGroupModalState = {
    members:Contact[]
    contactSearchText:string;
    contactSearchResults: ContactMember[]
}

export default class ManageGroupModal extends React.Component<ManageGroupModalProps, ManageGroupModalState> {

    constructor(props:ManageGroupModalProps){
        super(props)
        this.state = {
            members:[],

            // Search
            contactSearchText:"",
            contactSearchResults:[]
        }
    }

    componentDidMount(){
        this.fetchMembers()
    }

    fetchMembers(){
        const groupId = this.props.group.groupId
        API.groupMembers([groupId]).then(groups=>{
            const members = groups[0].contacts
            this.setState({members:members})
        }, response=>{
            console.log(response)
            // TODO: handle error
        })
    }

    // Contact Search
    didSearchContact(event:React.ChangeEvent<HTMLInputElement>){
        const searchText = event.target.value
        const groupId = this.props.group.groupId
        this.setState({contactSearchText:searchText})
        
        // TODO: Debounce search
        if(searchText.length>0){
            API.searchContact(groupId, searchText).then(results=>{
                console.log(results)
                this.setState({contactSearchResults:results})
            }, error=>{
                // TODO: handle error
            })
        } else {
            this.setState({contactSearchResults:[]})
        }
    }

    // AddMember
    didPressAddMember(contact:Contact){
        console.log(contact)
        const groupId = this.props.group.groupId
        const memberId = contact.memberId

        API.addGroupMember(groupId, memberId).then(response=>{
            this.setState({
                contactSearchText:"",
                contactSearchResults:[]
            })
    
            this.fetchMembers()
        }, error=>{
            // TODO: handle error
            console.log(error)
        })
    }

    didPressRemoveMember(contact:Contact){
        console.log(contact)

        const groupId = this.props.group.groupId
        const memberId = contact.memberId

        API.removeGroupMember(groupId,memberId).then(response=>{
            this.setState({
                contactSearchText:"",
                contactSearchResults:[]
            })
    
            this.fetchMembers()
        }, error=> {
            // TODO: handle error
            console.log(error)
        })
    }

    render(){
        const MemberItems = (props:any) => {
            if(this.state.members.length === 0){
                return (
                    <tr>
                        <td>No Contacts Found</td>
                    </tr>
                )
            } else {
                const members = this.state.members.map((contact, index)=>{
                    return (
                        <tr>
                            <td>{contact.name}</td>
                            <td>
                                <Button variant="danger" onClick={this.didPressRemoveMember.bind(this, contact)} >Remove</Button>
                            </td>
                        </tr>
                    )
                })
            return (<>{members}</>) 
            }
        }

        const SearchResultItems = (props:any) => {
            if(this.state.contactSearchResults.length === 0){
                return (
                    <tr>
                        <td>No Contacts Found</td>
                    </tr>
                )
            } else {
                const items = this.state.contactSearchResults.map(contact=>{
                    return (
                        <tr>
                            <td>{contact.name}</td>
                            <td>
                                { contact.isMember ? (<Badge pill variant="secondary">Already Member</Badge>) : (<Button variant="primary" onClick={this.didPressAddMember.bind(this, contact)} >Add</Button>)  }
                            </td>
                        </tr>
                    )
                }) 
                return (<>{items}</>)
            }
        }

        return (
            <Modal show={this.props.show} onHide={this.props.didPressDone}>
                <Modal.Header>
                    <Modal.Title>Manage: {this.props.group.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label><strong>Add Contact</strong></Form.Label>
                            <Form.Control type="text" placeholder="Search Contact..." value={this.state.contactSearchText} onChange={this.didSearchContact.bind(this)} />
                            <br />
                            <div style={{height:200, overflowY:"auto"}}>
                                <Table bordered hover>
                                    <tbody>
                                        <SearchResultItems />
                                    </tbody>
                                </Table>
                            </div>
                        </Form.Group>
                    </Form>
                    <hr />
                    <Form>
                        <Form.Group>
                            <Form.Label><strong>Members of {this.props.group.name}</strong></Form.Label>
                            <Form.Control type="text" placeholder="Filter Members..." />
                            <br />
                            <div style={{height:200, overflowY:"auto"}}>
                                <Table bordered hover>
                                    <tbody>
                                        <MemberItems />
                                    </tbody>
                                </Table>
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.props.didPressDone}>Done</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}